export default {
  // Este componente no tiene cadenas de texto estáticas traducibles
  // Usa datos dinámicos pasados desde props
}
